---
title: Business networking
slug: wo2015004645
type: patent
status: published
featured: true
summary: A method for networking service providers, investors, and businesses by correlating profiles and suggesting a connection when the match exceeds a threshold.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2015-01-15"
lastReviewedAt: "2026-10-02"
audiences:
  - product-developer
  - business
themes:
  - network-analysis
  - innovation-systems
sourceUrl: https://patents.google.com/patent/WO2015004645A2
originalAuthor: Jay van Zyl
sourceRelationship: first-party patent record
rightsStatus: first-party
seoDescription: Patent WO2015004645A2 — business networking by correlating profiles across country, industry, funding, and data freshness.
canonicalPath: /resources/wo2015004645
patentNumber: WO2015004645A2
documentHref: /documents/patents/wo2015004645a2-business-networking.pdf
---

import { PatentPages } from "@/features/publications/PatentPages"

[WO2015004645A2 on Google Patents](https://patents.google.com/patent/WO2015004645A2) · [Download the patent document (PDF)](/documents/patents/wo2015004645a2-business-networking.pdf)

<PatentPages id="wo2015004645" />

A method of networking interested business participants. Any one of a prospective service provider, investor, or business uploads profile details: country of operation, focus industry, amount and type of funding requested or offered, a data velocity indicator, and a data freshness indicator. The method correlates two sets of profile details, generates a correlation factor for the match, and suggests that the parties be networked when that factor exceeds a predefined minimum.

Profiles include country, industry, funding asked or offered, data velocity, and data freshness. The system correlates two profiles and suggests a connection when the match exceeds a threshold. It is an early statement of the same idea as the later offer graphs: a relationship is evidence, and a threshold is a decision.
